var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#FFF1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.465 21.8828V30.8728C50.465 32.0903 50.9525 33.2603 51.815 34.1228C52.6822 34.9862 53.8563 35.4708 55.08 35.4703H65.3925",
    stroke: "#FFAE00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1175 34.1176H42.28M34.1175 45.0001H55.8825M34.1175 55.8826H55.8825M65.625 36.4201V57.8401C65.5754 59.2411 65.2489 60.6185 64.6645 61.8929C64.0802 63.1672 63.2493 64.3133 62.22 65.2651C61.1898 66.2213 59.9813 66.9651 58.6635 67.4541C57.3458 67.9431 55.9446 68.1677 54.54 68.1151H35.565C34.1518 68.1797 32.7398 67.9647 31.4099 67.4825C30.08 67.0003 28.8584 66.2603 27.815 65.3051C26.7757 64.3507 25.9364 63.1993 25.3458 61.9178C24.7553 60.6363 24.4253 59.2502 24.375 57.8401V32.1551C24.4246 30.754 24.7511 29.3766 25.3354 28.1023C25.9198 26.8279 26.7507 25.6819 27.78 24.7301C28.8102 23.7739 30.0187 23.03 31.3365 22.541C32.6542 22.052 34.0554 21.8274 35.46 21.8801H49.745C51.9257 21.8724 54.0307 22.6792 55.6475 24.1426L63.0475 30.9476C63.8371 31.6278 64.4747 32.4666 64.9188 33.4094C65.3629 34.3523 65.6035 35.3781 65.625 36.4201Z",
    stroke: "#FFAE00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo2);
export default __webpack_public_path__ + "static/media/demo2.d04b19e815f2fb3d932fbde5ab5b38a0.svg";
export { ForwardRef as ReactComponent };